export default {
  name: 'canonical-link',
  computed: {
    href () {
      if (window.location.origin.endsWith('/')) {
        let origin = window.location.origin.length
        return origin.substring(0, origin.length - 1) + this.$route.fullPath
      }
      return window.location.origin + this.$route.fullPath
    }
  },
  mounted () {
    this.$el.remove()
    document.querySelector('head').appendChild(this.$el)
  }
}



// WEBPACK FOOTER //
// ./src/components/canonical-link/script.js